<template>
    <div class="article flex-wrap" v-bind:class="{ inactive: !artikel.FLAG_AKTIV }">
        <div class="col-3 col-md-2 product-name">
            <img :src="artikel.HAUPTSCHUSS_URL" alt="preview" height="auto" class="img-fluid img-fluid-artikel" style="" v-bind:class="{ inactive: !artikel.FLAG_AKTIV }">
        </div>
        <div class="product-details" v-bind:class="{ inactive: !artikel.FLAG_AKTIV, 'col-8 col-sm-6': optionen.flagMengeneingabe, 'col-6': !optionen.flagMengeneingabe }">
            <div class="cart-item-details">
                <a :href="artikel.URL" :title="artikel.NAME" class="artikel-url">{{ artikel.NAME }}</a>
                <ul>
                    <li v-bind:class="{ inactive: !artikel.FLAG_AKTIV }">
                        <p class="farbwerte">{{ Verfuegbarkeit }}:
                            <span class="umbruch-klein d-block" v-html="artikel.LIEFERBARKEIT"></span>
                        </p>
                    </li>
                    <li v-if="artikel.FARBE != null" v-bind:class="{ inactive: !artikel.FLAG_AKTIV }">
                        <p class="farbwerte">
                            <span v-if="Farbwert">{{ Farbwert }}</span>
                            <span>
                                <img class="hoehe-farbe artikelbild-farbe" :src="artikel.FARBE_BILD" :alt="artikel.FARBE" :title="artikel.FARBE">
                                <span class="hoehe-farbe-zeichen farbwerte"> {{ artikel.FARBE }}</span>
                            </span>
                        </p>
                    </li>
                    <li v-bind:class="{ inactive: !artikel.FLAG_AKTIV }" v-if="artikel.GRUNDPREIS != '' && optionen.flagShop">
                        <p class="farbwerte">{{ Grundpreis }}:
                            <span class="umbruch-klein" v-html="artikel.GRUNDPREIS"></span>
                        </p>
                    </li>
                    <li v-bind:class="{ inactive: !artikel.FLAG_AKTIV }" v-if="(artikel.GRUNDPREIS == '') && (artikel.FARBE == null)">
                        <p class="farbwerte">&nbsp;</p>
                    </li>
                    <li v-if="optionen.flagShop">
                        <span class="artikel-details preis_details" v-html="preisArtikel" v-bind:class="{ inactive: !artikel.FLAG_AKTIV }"></span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-sm-3 col-md-4" v-if="optionen.flagMengeneingabe && artikel.FLAG_AKTIV && optionen.flagShop">
            <div class="row align-items-center">
                <div class="col-4">
                    <input type="text" v-model="menge" min="0" style="width: 50px;"
                        @change="mengeAenderung($event)"
                    />
                </div>
                <div v-if="optionen.flagMengeneingabe && optionen.flagShop" class="col-5">
                    <span v-if="artikel.FLAG_AKTIV" v-html="gesamtpreisArtikel"></span>
                </div>
                <div v-if="artikel.FLAG_AKTIV" class="col-3 text-right text-sm-center">
                    <a class="remove-item" title="Entfernen" v-on:click="artikelEntfernen">
                        <i class="icons8-delete-filled look-icon"></i>
                    </a>
                </div>
                <div v-else class="col-3 text-right text-sm-center">
                    <a class="remove-item" title="Hinzufügen" v-on:click="artikelHinzufuegen">
                        <i class="icons8-delete-filled look-icon"></i>
                    </a>
                </div>
            </div>
        </div>
        <div v-else class="col-3 col-md-4 product-remove text-right">
            <a v-if="artikel.FLAG_AKTIV == 1" class="remove-item" title="Entfernen" v-on:click="artikelEntfernen">
                <i class="icons8-delete-filled look-icon"></i>
            </a>
            <a v-else class="remove-item" title="Hinzufügen" v-on:click="artikelHinzufuegen">
                <i class="icons8-delete-filled look-icon"></i>
            </a>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Artikel',
        props: {
            artikel: Object,
            optionen: Object,
            texte: Object,
        },
        data() {
            return {
                selectedValue: 1,
                Farbwert: this.optionen.texte.farbe,
                Verfuegbarkeit: this.optionen.texte.verfuegbar,
                Grundpreis: this.optionen.texte.grundpreis,
                A_title_Add: this.optionen.texte.title_add,
                A_title_Remove: this.optionen.texte.title_remove,
                menge: 1,
            }
        },
        computed: {
            preisArtikel() {
                return this.artikel.WAEHRUNG + " " + this.artikel.PREIS.replace(/\./, ",");
            },
            gesamtpreisArtikel() {
                var menge = this.menge;
                if (isNaN(menge)) {
                    return this.artikel.PREIS.replace(/\./, ",");
                }

                return this.artikel.WAEHRUNG + "&nbsp;" + (parseFloat(this.artikel.PREIS) * this.menge).toFixed(2).replace(/\./, ",");
            }
        },
        methods: {
            artikelEntfernen(event) {
                this.$set(this.artikel, 'FLAG_AKTIV', false);
                this.$emit('aktualisieren-einkaufstasche',
                {
                    artikelId: this.artikel.ID_PRODUKT,
                    artikelPreis: this.artikel.PREIS,
                    menge: 0
                });
            },
            artikelHinzufuegen(event) {
                this.$set(this.artikel, 'FLAG_AKTIV', true);
                this.$emit('aktualisieren-einkaufstasche',
                {
                    artikelId: this.artikel.ID_PRODUKT,
                    artikelPreis: this.artikel.PREIS,
                    menge: this.menge,
                });
            },
            mengeAenderung() {
                if (isNaN(this.menge) || this.menge == '') {
                    this.menge = 1;
                }
                this.$emit('aktualisieren-einkaufstasche',
                {
                    artikelId: this.artikel.ID_PRODUKT,
                    artikelPreis: this.artikel.PREIS,
                    menge: this.menge,
                });
            }
        },
    }

</script>


// WEBPACK FOOTER //
// src/components/Artikel.vue